import styled from 'styled-components'
import { OrangeColor } from '../../../constants/constants'
import { SimCardDownload } from 'styled-icons/material-outlined'
import { BqSelect, BqDialog } from '@beeq/react'

export const ExportButton = styled.button`
  margin-left: 5px;
  margin-right: 5px;
  margin-top: 12px;
  display: block;
  height: fit-content;
  border: 1px solid ${OrangeColor};
  padding: 3px 8px;
  border-radius: var(--bq-radius-m);
  background: unset;
  cursor: pointer;
  position: relative;
`

export const ExportLabel = styled.span`
  color: ${OrangeColor};
  line-height: 1;
`

export const Dialog = styled(BqDialog)`
  &::part(body) {
    text-align: left;
  }
`

export const H5Bold = styled.h5`
weight: 700;
size: 24px;
line-height: 36px;
`

export const ExportIcon = styled(SimCardDownload)`
  color: ${OrangeColor};
  margin-right: 8px;
`

export const ExportSelect = styled(BqSelect)`
  width: 200px;
  &::part(panel) {
    height: 220px;
  }
`
